export const artist = {
  publisher_profile: "Publisher Profile",
  donate: "Donate",
  editArtist: "Edit proflie",
};
